import type { FilterDefinition, FilterValueType } from "./structured-search-schema";

export enum StructuredSearchField {
  RequestId = "pl_id",
  UserId = "user_id",
  Status = "status",
  Prompt = "prompt",
  Model = "engine",
  Tags = "tags",
  ProviderType = "provider_type",
  InputText = "input_text",
  OutputText = "output_text",
  ThinkingText = "thinking_text",
  Metadata = "metadata",
  Signal = "signal",
  Output = "output",
  InputVariables = "input_variables",
  Cost = "cost",
  Latency = "latency_ms",
  ToolNames = "tool_names",
  ErrorType = "error_type",
  UserIntent = "user_intent",
  AgentIntent = "agent_intent",
}

export enum StructuredSearchSuggestionField {
  Prompt = "prompt",
  MetadataKeys = "metadata_keys",
  MetadataValues = "metadata_values",
  OutputKeys = "output_keys",
  OutputValues = "output_values",
  InputVariableKeys = "input_variable_keys",
  InputVariableValues = "input_variable_values",
}

export const NESTED_FIELDS: readonly string[] = [
  StructuredSearchField.Metadata,
  StructuredSearchField.Signal,
  StructuredSearchField.Output,
  StructuredSearchField.InputVariables,
];

export interface PromptFilterValue {
  prompt_id: number;
  prompt_version_number?: number;
}

export interface WorkflowFilterValue {
  workflow_id: number;
  workflow_version_number?: number;
}

export type VersionedEntityFilterValue = PromptFilterValue | WorkflowFilterValue;

export enum TraceVersionSuggestionField {
  TracePromptVersions = "trace_prompt_versions",
  TraceWorkflowVersions = "trace_workflow_versions",
  SpanPromptVersions = "span_prompt_versions",
  SpanWorkflowVersions = "span_workflow_versions",
  SubtreePromptVersions = "subtree_prompt_versions",
  SubtreeWorkflowVersions = "subtree_workflow_versions",
}

export type FilterValue =
  | string
  | number
  | boolean
  | string[]
  | number[]
  | [number, number]
  | { amount: number; unit: "minutes" | "hours" | "days" }
  | PromptFilterValue
  | PromptFilterValue[]
  | WorkflowFilterValue
  | WorkflowFilterValue[]
  | VersionedEntityFilterValue
  | VersionedEntityFilterValue[];

export interface Filter {
  id: string;
  field: string;
  type: FilterValueType;
  operator: string;
  value: FilterValue;
  valueDisplay?: string;
  multiValueDisplay?: string[];
  nestedKey?: string;
  nestedKeyDisplay?: string;
  icon?: FilterDefinition["icon"];
  iconClassName?: string;
}

export interface StructuredFilterRequest {
  field: string;
  operator: string;
  value: FilterValue;
  nestedKey?: string;
}

export interface StructuredFilterGroupRequest {
  logic: "AND" | "OR";
  filters: (StructuredFilterRequest | StructuredFilterGroupRequest)[];
}

export interface OperatorDefinition {
  operator: string;
  display: string;
  valueInput?: "none" | "text" | "number" | "date" | "daterange" | "dropdown";
}
